import React from "react";
import { useTranslation } from "react-i18next";
import { FiGlobe } from "react-icons/fi";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const isArabic = i18n.language === "ar";

  const toggleLanguage = () => {
    const newLang = isArabic ? "en" : "ar";

    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("i18nextLng", newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="text-dark hover:text-primary flex items-center gap-2 text-lg font-medium transition hover:cursor-pointer"
    >
      <FiGlobe className="text-xl" />
      {isArabic ? "EN" : "العربية"}
    </button>
  );
};

export default LanguageSwitcher;
